import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { gsap } from 'gsap'
import { useEffect } from "react";

function Porfolio() {
    const Porfolio = [
        { P: 'Web development', L: '/web-development', C: 'image web' },
        { P: 'Other projects', L: '/other-proyects', C: 'image other' },
    ];
    
    useEffect(() => {
        gsap.from('.card',
            {
                duration: 0.1,
                scale: 0,
                stagger: 0.1,
                opacity: 0
            })
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>Dev Grimaldo | Porfolio</title>
                <meta name="description" content="Welcome to my portfolio, I am a frontend web developer"></meta>
            </Helmet>
            <section className="Proyects">
                <h2 className="">Proyects</h2>
                <div className='listPorfolio'>
                    {Porfolio.map(pro => (
                        <Link key={pro.P} to={pro.L} >

                            <div className='card'>
                                <div className='card-image'> <div className={pro.C}></div> </div>
                                <p className='card-title'> {pro.P} </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </React.Fragment>
    );
}
export default Porfolio;